class SectionQA {
    init(){
        const cardsFlip = document.querySelectorAll('.card-flip');
        if (cardsFlip.length > 0) {
            cardsFlip.forEach(card => {
                card.addEventListener('click', () => {
                    // Check if the clicked card is already active
                    const isActive = card.classList.contains('active');
                    // Remove 'active' class from all cards
                    cardsFlip.forEach(crdF => crdF.classList.remove('active'));
                    // Add 'active' class to the clicked card only if it was not active
                    if (!isActive) {
                        card.classList.add('active');
                    }
                });
            });
        }
    } 
}
export default SectionQA